import { NodeClass } from '@modules/campaigns/Domain/NodeClass';
import { NodeType } from '@modules/campaigns/Domain/Enums/NodeType';
import { AssaignCampaignConfig } from '@modules/campaigns/Domain/Interfaces/INodeConfig';
import { getValidationErrorMessage, ValidationError } from '@modules/campaigns/Domain/Enums/ValidationErrors';
import { NodeValidationError } from '@modules/campaigns/Domain/Interfaces/NodeValidationError';

export class AssaignCampaignNode extends NodeClass {
  constructor(id: string, position: { x: number; y: number }, config: AssaignCampaignConfig) {
    super(id, NodeType.AssignCampaign, position, config);
  }

  isEmptyConfig(): boolean {
    return this.config['targetCampaignId'] == null;
  }

  addChild(node: string): void {
    return;
  }

  addParent(node: string): void {
    if (this.parentNodes.length === 0) this.parentNodes.push(node);
  }

  initNodeConfig(): void {
    (this.config as AssaignCampaignConfig).targetCampaignId = null;
  }

  validate(): NodeValidationError[] {
    const errors: NodeValidationError[] = [];

    if (this.isEmptyConfig()) {
      errors.push({
        nodeId: this.id,
        errorMessage: getValidationErrorMessage(ValidationError.NO_TARGET_IDS, {
          nodoType: 'Asignar Campaña',
        }),
      });
    }

    return errors;
  }

  override validateConnectivity(): NodeValidationError[] {
    if (this.parentNodes.length === 0) {
      return [
        {
          nodeId: this.id,
          errorMessage: getValidationErrorMessage(ValidationError.NODE_MISSING_PARENT),
        },
      ];
    }
    return [];
  }
}
